// Scripts librairies
// import { docReady } from './js/libs/utils'

// Global styles
import './scss/custom_dark'

// Charge la base commune
require('./common.js')

// docReady(function () {
//   console.log('News detail template')
// })
